/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overlay[_ngcontent-%COMP%]{position:fixed;display:block;width:100%;height:100%;top:0;left:0;background-color:rgba(74,74,74,.8);z-index:99999}.spinner[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}\n/*# sourceMappingURL=loader.component.css.map*/"];
export { styles as styles };
